import config from 'config';
import sfax from 'sfax';

sfax.baseUrl = '';

const { domain, homeDomain, homeOnlineDomain } = config;

export default {
    getHomeFeed: payload => sfax({
        url: '/api/news/design/list',
        // url: '/MOCK/api/design',
        data: payload
    }),
    getAsyncAds: payload => sfax({
        url: '/api/op/getOpInfoByIds',
        // url: '/MOCK/api/ads',
        data: payload
    }),
    postCal:  payload => sfax({
        url: `${homeDomain}/decoration/fapi/m/calculate/decorationQuote`,
        data: payload,
        type: 'post',
        withCredentials: true
    }),
    postDesign:  payload => sfax({
        url: `${homeDomain}/decoration/fapi/iwantdec.json`,
        data: payload,
        type: 'post',
        withCredentials: true
    }),
    setcityCookie:  payload => sfax({
        url: `${homeDomain}/user/locate`,
        data: payload,
        withCredentials: true
    }),
    postClue: payload => sfax({
        url: '/api/freeDesign',
        data: payload,
        type: 'post',
        contentType: 'application/json'
    })
};



// WEBPACK FOOTER //
// ./src/model/api/home.js